export const AI_TOKEN_USAGE_EVENT = 'superturbo-ai-token-usage'

export function publishAiTokenUsage (usage) {

  if (!usage || typeof usage.totalTokens !== 'number' || typeof window === 'undefined') return

  window.dispatchEvent(new CustomEvent(AI_TOKEN_USAGE_EVENT, { detail: usage }))
}
